import React, {useCallback, useEffect, useState} from 'react';
import {EquipmentList} from "../../../../components/admin/equipment/EquipmentList";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {equipmentResultCollectionType, equipmentResultType} from "../../../../types/Api/EquipmentResultType";
import {equipmentHydrator} from "../../../../models/hydrator/equipmentHydrator";
import {equipment} from "../../../../models/equipment";
import {Pagination} from "../../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Tab} from "../../../../components/admin/equipment/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [equipments, setEquipments] = useState([] as equipment[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findEquipment = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'label',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<equipmentResultCollectionType> = ApiService.get('/equipment', apiFilters) as Promise<equipmentResultCollectionType>;

    result
      .then((r: equipmentResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setEquipments(r._embedded.equipments.map((equipment: equipmentResultType) => {
          return equipmentHydrator.hydrate(equipment);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setEquipments([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findEquipment();
  }, [findEquipment]);

  return (
    <>
      <BoxTitle title="Gestion de l'équipement"/>
      <Tab/>
      <EquipmentList equipments={equipments} loading={loading} refresh={findEquipment}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/equipment/equipment/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un équipement
        </NavLink>
      </div>
    </>
  )
}